import { Fragment, useContext, useEffect, useState } from 'react';
import './DetailsMail.scss';
import { Col, Form, Row } from 'react-bootstrap';
import Validator from '../../../../Handler/Validator';
import Toast from '../../../Form/Toast';
import eye from '../../../../assets/icons/outline_eye_bright.svg';
import eyeOff from '../../../../assets/icons/outline_eye_bright-off.svg';
import Ajax from '../../../../Handler/Ajax';
import GovSpinner from '../../../Form/GovSpinner';
import alert from '../../../../assets/icons/alert-circle-red.svg';
import info from '../../../../assets/icons/info-blue.svg';
import timer from '../../../../assets/icons/timer.svg';
import SubmitBtn from '../../../Form/submit-button/submit-button.component';
import LoginContext from '../../../../store/login-context';

declare var _curLang: any;
declare function Translate(key: string): string;

const DetailsMail = props => {

  const ctx = useContext(LoginContext);

  const [isMailValid, setIsMailValid] = useState(false);
  const [isMailConfirmValid, setIsMailConfirmValid] = useState(false);
  const [mail, setMail] = useState('');
  const [mailConfirm, setMailConfirm] = useState('');
  const [serverMessage, setServerMessage] = useState('');
  const [mailDirty, setMailDirty] = useState(false);
  const [mailConfirmDirty, setMailConfirmDirty] = useState(false);
  const [step, setStep] = useState(1);
  const [otpCode, setOtpCode] = useState('');
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [otpDirty, setOtpDirty] = useState(false);
  const [controlType, setControlType] = useState('password');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(props.currentState === "updateDetailsGetEmailOtpInput"){
      setStep(2);
    }
  },[])
  
  useEffect(() => {
    if(mail.length > 0 && !mailDirty){
      setMailDirty(true);
    }
    if(mailConfirm.length > 0 && !mailConfirmDirty){
      setMailConfirmDirty(true);
    }
    if(otpCode.length > 0 && !otpDirty){
      setOtpDirty(true);
    }
  },[mail, mailConfirm,otpCode]);

  const handleMailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMail(e.target.value.trim());
    setIsMailConfirmValid(false);
    var mailValidStatus = Validator.IsValidEmail(e.target.value.trim());
    setIsMailValid(mailValidStatus);
    if(mailValidStatus){
      document.getElementById("mail")?.setAttribute("aria-invalid","false");
    }
    else{
      document.getElementById("mail")?.setAttribute("aria-invalid","true");
    }
    setMailConfirm('');
    setMailConfirmDirty(false);    
  };

  const handleMailConfirmChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMailConfirm(e.target.value.trim());
    setIsMailConfirmValid(mail === e.target.value.trim() ? true : false); 
    if(mail === e.target.value.trim()){
      document.getElementById("mailConfirm")?.setAttribute("aria-invalid","false");
    }
    else{
      document.getElementById("mailConfirm")?.setAttribute("aria-invalid","true");
    }  
  };

  const otpValidationMessage = () => {
    return otpCode.length === 0
      ? Translate('N_General_Error_Mandatory_Field')
      : Translate('N_General_Error_PIN_too short');
  };

  const getMailOtp = () => {
    if (!isMailValid || !isMailConfirmValid) return;

    setLoading(true);
    setServerMessage('');    

    if (ctx.devMode) {
      setLoading(false);      
      setStep(2);      
    } else {
      Ajax.SendUserMail(mail)
        .then(() => {
          setLoading(false);
          setStep(2); 
        })
        .catch((error) => {
          setLoading(false);
          setIsMailValid(false);
          setIsMailConfirmValid(false);
          setMailDirty(false);
          setMailConfirmDirty(false);
          setServerMessage(Translate(error) !== '' 
                              ? Translate(error) 
                              : Translate('N_General_Error_SYSTEM_ERROR'));         
        });
    }
  };

  // Step 2
  const sendMailOtp = () => {
    if (!isOtpValidCheck(otpCode)) return;

    setLoading(true);
    setServerMessage('');  

    if (ctx.devMode) {
      setLoading(false);
      props.mailStepCompleted();
    } else {
      Ajax.SendUserMailOtp(otpCode)
        .then(() => {
          setLoading(false);
          props.mailStepCompleted();
        })
        .catch((error) => {
          setLoading(false);
          setServerMessage(Translate(error) !== '' 
                              ? Translate(error) 
                              : Translate('N_General_Error_SYSTEM_ERROR'));          
        });
    }
  };

  const handleOtp = (e: React.ChangeEvent<HTMLInputElement>) => {    
    setOtpCode(e.target.value.replace(/[^\d]/g,''));
    var otpValidStatus = isOtpValidCheck(e.target.value);
    setIsOtpValid(otpValidStatus);   
    
    if(otpValidStatus){
      document.getElementById("mailOtp")?.setAttribute("aria-invalid","false");
    }
    else{
      document.getElementById("mailOtp")?.setAttribute("aria-invalid","true");
    }
  };

  const isOtpValidCheck = (otp: string) => {
    const regex = /^[0-9]{6}$/;
    return regex.test(otp);
  };
 
  const handleOtpEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      sendMailOtp();
      event.preventDefault();
    }
  };

  const onPasteHandler = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
  };

  const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {      
      getMailOtp();
    }
  };
  const onBackHandler = () => {
    if (ctx.devMode){
      setStep(1);
      return;
    }

    setLoading(true); 
    Ajax.ResetUserStatus()
    .then(() => {  
      setLoading(false);          
      setStep(1);
    })
    .catch(() => {   
      setLoading(false); 
      setServerMessage(Translate('N_General_Error_SYSTEM_ERROR'));           
    });     
  };
  return (
    <Form className='normal-form'>
      {serverMessage.length > 0 && (
        <Toast message={serverMessage} />
      )}
      
      <GovSpinner show={loading} />

      {step === 1 ? (
        <Fragment>
          <Row className='baseline'>
            <Form.Group
              controlId='mail'
              className={
                _curLang === 'en' || _curLang === 'ru' ? 'ms-0' : 'ms-3'
              }
              as={Col}
              xl={5}
              lg={5}
              md={5}
              sm={12}
              xs={12}
            >
              <Form.Label className='py-2'>
                {Translate('N_General_SignUp_info_6_mobile')}
              </Form.Label>
              <Form.Control
                type='text'
                autoComplete='off'
                aria-required="true"
                value={mail}
                onChange={handleMailChange}
                onKeyPress={handleEnter} 
                aria-describedby = "mailDesc"  
                aria-invalid="false"
                aria-errormessage="mailError"          
                className={
                  !isMailValid && mailDirty
                    ? 'ltrText error-control'
                    : 'ltrText'
                }
              ></Form.Control>

              {!isMailValid && mailDirty ? (
                <Form.Text className='error mt-1 d-flex align-items-start'>
                  <img src={alert}  className='error-alert' />
                  &nbsp;
                  <span className='error-text' id='mailError'>
                    {mail.length === 0
                      ? Translate('N_General_Error_Mandatory_Field')
                      : Translate('N_General_Error_INVALID_EMAIL')}
                  </span>
                </Form.Text>
              ) : (
                <Form.Text className='mt-1 d-flex align-items-start'>
                  <img src={info}  className='info-icon' aria-hidden="true"/>
                  &nbsp;
                  <span className='small' id='mailDesc'>
                    {Translate('N_Login_personal_details_mail_4')}
                  </span>
                </Form.Text>
              )}
            </Form.Group>
            <Form.Group
              controlId='mailConfirm'
              as={Col}
              xl={5}
              lg={5}
              md={5}
              sm={12}
              xs={12}
            >
              <Form.Label className='py-2'>
                {Translate('N_General_SignUp_info_7_mobile')}
              </Form.Label>
              <Form.Control
                type='text'
                autoComplete='off'
                aria-required="true"
                value={mailConfirm}
                onChange={handleMailConfirmChange}
                onKeyPress={handleEnter}
                onPaste= {onPasteHandler}                
                aria-invalid="false"
                aria-errormessage="mailConfirmError"  
                className={
                  !isMailConfirmValid &&
                  mailConfirmDirty
                    ? 'ltrText error-control'
                    : 'ltrText'
                }
                disabled={!isMailValid}
              ></Form.Control>
              {!isMailConfirmValid && mailConfirmDirty &&                
                (<Form.Text className='error mt-1 d-flex align-items-start'>
                  <img src={alert}  className='error-alert' />
                  &nbsp;
                  <span className='error-text' id='mailConfirmError'>
                    {mailConfirm.length === 0
                      ? Translate('N_General_Error_Mandatory_Field')
                      : Translate('N_General_Error_fields_dont_match')}
                  </span>
                </Form.Text>)
              }
            </Form.Group>
          </Row>
          <Row className='mb-3'>
            <Col xs={5} className='mobileWidth'>                
              <SubmitBtn
                title={Translate('N_Login_personal_send_token')}
                id="mailSubmit"
                action={getMailOtp}
                showIcon={false}
                disabled={
                  !isMailValid || !isMailConfirmValid
                }
              />
            </Col>
          </Row>
        </Fragment>
      ) : (
        <Fragment>
          <div className='regular'>
            {Translate('N_General_SignUp_confirm_mail_info_1')}
            <span className='font-weight-bold'>&nbsp;{mail}</span>
          </div>
          <div className='regular'>
            {Translate('N_General_SignUp_confirm_mail_info_2T')}
          </div>
          <Row className='mt-3 mb-4'>
            <Form.Group
              controlId='mailOtp'
              as={Col}
              xl={4}
              lg={4}
              md={5}
              sm={12}
              xs={12}
            >              
              <Form.Label className='my-1 d-flex align-items-center justify-content-between'>
                    <div>
                      {Translate('N_Login_reset_password_stage_2')}                                            
                    </div>
                    <div 
                      className='mx-2 d-flex align-items-center'
                      aria-hidden="true"
                      onClick={() =>
                        setControlType(
                          controlType === 'password'
                            ? 'text'
                            : 'password'
                        )
                      }
                    >
                      <img
                        src={controlType === 'password' ? eye : eyeOff}
                        width='22px'
                        height='18px'
                        alt=''
                        role='button'
                        tabIndex={0}
                        className={
                          otpCode
                            ? 'mx-1 password-view-show'
                            : 'mx-1 password-view-hide'
                        }
                        
                      />
                      <span 
                        className={
                          otpCode
                            ? 'password-view-show'
                            : 'password-view-hide'
                        }
                      >
                        {controlType === 'password' 
                          ? Translate('N_Login_Bio_ID_OTP_Show_OTP')
                          : Translate('N_Login_Bio_ID_OTP_Hide_OTP')
                        }
                      </span>                      
                    </div>
                </Form.Label>
              <Form.Control
                type={controlType}
                value={otpCode}
                aria-required="true"
                onChange={handleOtp}
                onKeyPress={handleOtpEnter}
                maxLength={6}
                placeholder="_ _ _ _ _ _"
                aria-describedby = "otpDesc"  
                aria-invalid="false"
                aria-errormessage="otpError"  
                className={`gov-black
                  ${!isOtpValid && otpDirty
                    ? ' error-control'
                    : ''
                  }
                `}
              />             
              {!isOtpValid && otpDirty ? (
                <Form.Text className='error d-flex align-items-start'>
                  <img src={alert} alt='' className='error-alert' aria-hidden="true" />
                  &nbsp;
                  <span className='error-text' id='otpError'>
                    {otpValidationMessage()}
                  </span>
                </Form.Text>
              ) : (
                <Form.Text className='small dark-blue d-flex align-items-center'>
                  <img src={timer} alt='' width='16px' height='19px' aria-hidden="true"/>
                  &nbsp;
                  <span className='py-2' id='otpDesc'>
                    {Translate('N_General_otp_time_limit_1')}
                  </span>
                </Form.Text>
              )}
            </Form.Group>
          </Row>
          
          <div className='small dark-blue'>
            {Translate('N_General_SignUp_receive_otp_fail')}
          </div>
          <div className='d-flex align-items-center'>
            <span aria-hidden="true">&nbsp;&nbsp;</span>                        
            <a id='goBackLink' className='goBackLink' onClick={onBackHandler} >
              {Translate('N_General_SignUp_receive_otp_fail_link')}
            </a>                                                
          </div>  
          <Row className='mb-3'>
            <Col 
              xl={4}
              lg={4}
              md={5}
              sm={12}
              xs={12}>             
              <SubmitBtn
                title={Translate('N_General_next_butten')}
                id="mailOtpSubmit"
                action={sendMailOtp}
                showIcon={false}
                disabled={!isOtpValid}
              />
            </Col>
          </Row>
        </Fragment>
      )}
    </Form>
  );


  
};
export default DetailsMail;

